import i18n from '../locales';
import store from '../store';
import operationEscl from '../locales/es-CL/operations.json';
import operationEsmx from '../locales/es-MX/operations.json';
import operationEsco from '../locales/es-CO/operations.json';
import operationEnus from '../locales/en-US/operations.json';
import RouteDetailMap from '../components/RouteDetailMap.vue';
import GoogleMapsApiLoader from 'google-maps-api-loader';

import moment from 'moment';
import axios from 'axios';

export default {
  props: ['operation', 'callback'],
  name: 'OperationDetail',
  components: {
    RouteDetailMap,
    GoogleMapsApiLoader,
  },
  data() {
    return {
      gapi: null,
      currentTab: 'location',
      operationTypeOptions: [
        {
          type: 'DELIVERY',
          name: 'Entrega',
        },
        {
          type: 'COLLECTION',
          name: 'Retiro',
        },
      ],
      badges: {
        NOTDONE: {
          background: '#B3C1C6',
          color: '#03475E',
        },
        DONE: {
          background: '#E6F1E4',
          color: '#52A145',
        },
        REJECTED: {
          background: '#F4DADB',
          color: '#e62121',
        },
        CANCELED: {
          background: '#F4DADB',
          color: '#e62121',
        },
        PARTIALLYDONE: {
          background: '#F2E6D5',
          color: '#eeb71f',
        },
      },
      tags: [],
      selectedImage: null,
      imageText: null,
      showViewer: false,
      loadingOperationDetail: true,
    };
  },
  async created() {},
  methods: {
    async syncGapi() {
      GoogleMapsApiLoader({
        libraries: ['places', 'marker'],
        apiKey: store.getters.apiKey,
      }).then(async (google) => {
        this.gapi = google;
        await this.loadPoints();
      });
    },
    async loadPoints() {
      if (
        this.operation != null &&
        (this.currentTab === 'location' || this.currentTab === 'evidences') &&
        this.gapi != null
      ) {
        console.log('cargando puntos');
        var operationList = [];
        this.processImage(this.operation.signatureBinary);
        const operationPlanned = {
          type: this.operation.type,
          typeName: this.operation.type == 'DELIVERY' ? 'Entrega planificada' : 'Retiro planificado',
          index: 0,
          coordinates: {
            lat: this.operation.spot.address.lat,
            lng: this.operation.spot.address.lon,
          },
          state: 'PLANNED',
        };
        operationList.push(operationPlanned);
        if (this.currentTab === 'evidences') {
          const operationReal = {
            type: this.operation.type,
            typeName: this.operation.type == 'DELIVERY' ? 'Entrega real' : 'Retiro real',
            index: 0,
            coordinates: {
              lat: this.operation.lat,
              lng: this.operation.lon,
            },
            state: this.operation.relation ? this.operation.relation.idState : 'NOTENDED',
            scheduled: this.getFormatDate(this.operation.relation.actualEndOperationDate),
          };
          if (this.operation.relation.idState != 'NOTDONE' && this.operation.lat != 0 && this.operation.lon != 0) {
            operationList.push(operationReal);
          }
        }
        //Prepare map
        await this.$refs.map.setMultipleMarkers(this.gapi, operationList);
      }
    },
    async waitForElm(selector) {
      return new Promise((resolve) => {
        if (document.querySelector(selector)) {
          return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(() => {
          if (document.querySelector(selector)) {
            resolve(document.querySelector(selector));
            observer.disconnect();
          }
        });

        observer.observe(document.body, {
          childList: true,
          subtree: true,
        });
      });
    },
    async getTags() {
      try {
        const config = {
          headers: {
            'id-client': store.getters.clientId,
            Authorization: `Bearer ${store.getters.accessToken}`,
          },
        };
        const response = await axios.get(`${store.getters.urlAPI}/tag`, config);
        const result = response.data.data;
        this.tags = result;
      } catch (e) {
        console.log(e);
        if (e.response.data.message == 'No encontrado') {
          this.totalOperationsPending = 0;
          this.tags = [];
        }
      }
    },
    async getOperationRoute() {
      let url = `${store.getters.urlAPI}/operation?pageNum=-1&includeImages=true&excludeDepot=true&includeLocation=true&idRoute=${this.operation.relation.idRoute}&name=${this.operation.name}`;
      try {
        const response = await axios.get(url, {
          headers: {
            'id-client': store.getters.clientId,
            Authorization: `Bearer ${store.getters.accessToken}`,
          },
        });
        const result = await response.data.data.filter((item) => item.id === this.operation.id);
        if (result.length > 0) {
          this.operation = result[0];

          if (this.operation.relation.idState == "NEW") {
            this.operation.relation.idState = "NOTDONE";
          }
        }
      } catch (e) {
        console.log(e);
      }
    },
    cancel() {
      //this.$bvModal.hide('operation-detail-modal');
      if (this.callback) {
        this.callback();
      }
    },
    /**@author Jorge Pizarro Tapia
     * Metodo que permite interactuar con los .json de las traducciones.
     * @param {String} key, es el elemento del .json a utilizar.
     * @param {String} value, es la variable a insertar (en caso de que el elemento lo solicite).
     * @returns el resultado de la traduccion.
     */
    t(key, value) {
      return i18n.t(key, value);
    },
    async changeTab(navBar) {
      this.currentTab = navBar;
    },
    getOperatonType(type) {
      return this.operationTypeOptions.find((item) => item.type === type).name;
    },
    getFormatDate(operationDate) {
      return moment(operationDate).format('YYYY-MM-DD HH:mm [hrs.]');
    },
    getFormatHour(seconds) {
      let hours = Math.floor(seconds / 3600);
      let minutes = Math.floor((seconds % 3600) / 60);
      const ampm = hours >= 12 ? 'pm' : 'am';

      // Ajustar a formato 12h
      hours = hours % 12;
      hours = hours === 0 ? 12 : hours;

      const paddedMinutes = minutes.toString().padStart(2, '0');

      return `${hours}:${paddedMinutes} ${ampm}`;
    },
    transformIdState(state) {
      return state ? this.t(`operations.statesOperation.${state}`) : this.t(`operations.statesOperation.NOTDONE`);
    },
    secondsToMinute(seconds) {
      return (seconds / 60).toFixed(2);
    },
    getTag(idTags) {
      if (!Array.isArray(this.tags) || idTags.length == 0) {
        return '-';
      }
      const names = idTags
        .map((idTag) => {
          const tagFinded = this.tags.find((tag) => tag.id.toString() === idTag.toString());
          return tagFinded ? tagFinded.name : null;
        })
        .filter(Boolean); // remueve nulos
      return names.length > 0 ? names.join(', ') : '-';
    },
    async processImage(signatureBinary) {
      if (document.getElementById('my-img') != null) {
        let blob = new Blob([new Uint8Array(signatureBinary)], { type: 'image/png' } /* (1) */);
        document.getElementById('my-img').src = URL.createObjectURL(blob);
      }
    },
    getOperationTitle() {
      return this.t('operations.details.title') + ' "' + this.operation.name + '"';
    },
    viewImage(url, index) {
      this.selectedImage = url;
      this.imageText = this.getPhotoName(index);
      this.showViewer = true;
    },
    closeViewer() {
      this.showViewer = false;
    },
    getPhotoName(index) {
      return 'Foto ' + (index + 1);
    },
    hideModal(id) {
      this.$bvModal.hide(id);
      if (id === 'operation-detail-modal') {
        this.$destroy();
        this.$el.remove();
      }
    },
  },
  updated: function () {
    this.$nextTick(async function () {
      await this.loadPoints();
    });
  },
  computed: {
    clases() {
      const base = ['btn', 'width-button', 'margin-buttons', 'border-button'];
      base.push('btn-primary');
      return base.join(' ');
    },
  },
  async mounted() {
    if (this.operation.relation.idState == "NEW") {
      this.operation.relation.idState = "NOTDONE";
    }
    i18n.setLocaleMessage('es-CL', {
      ...i18n.messages['es-CL'],
      operations: operationEscl,
    });

    i18n.setLocaleMessage('es-MX', {
      ...i18n.messages['es-MX'],
      operations: operationEsmx,
    });

    i18n.setLocaleMessage('es-CO', {
      ...i18n.messages['es-CO'],
      operations: operationEsco,
    });

    i18n.setLocaleMessage('en-US', {
      ...i18n.messages['en-US'],
      operations: operationEnus,
    });
    this.$root.$on('bv::modal::hide', () => {
      this.$destroy(); // cleanup in component
      this.$el.remove();
    });
    this.loadingOperationDetail = true;
    await this.getTags();
    await this.getOperationRoute();
    await this.processImage(this.operation.signatureBinary);
    console.log(this.operation);
    await this.syncGapi();
    this.loadingOperationDetail = false;
  },
};
